import CoursesPage from './index';

const Fastlink = CoursesPage;

Fastlink.getInitialProps = CoursesPage.getInitialProps;

export default Fastlink;
